import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import Component from './Component';
import {getTourById, pageUnmounted} from './Actions';
import {addToCart, deleteFromCart, getCartTours} from '../Cart/Actions';

const stateToProps = (state) => ({
  tour: state.tour.tour,
  categories: state.main.tourCategories,
  getTourPromise: state.tour.promise.getTour,
  cartList: state.cart.list,
  cartError: state.cart.error,
  user: state.auth.user,
  cities: state.main.cities,
});

const dispatchToProps = (dispatch) =>({
  getTourById: (tourId) => {
    dispatch(getTourById(tourId))
  },
  pageUnmounted: () => {
    dispatch(pageUnmounted())
  },
  addToCart: (id, cityId) => {
    dispatch(addToCart(id, cityId))
  },
  deleteFromCart: (id) => {
    dispatch(deleteFromCart(id))
  },
  getCartTours: (cb, tourIds) => {
    dispatch(getCartTours(cb, tourIds))
  }
});

export default withRouter(connect(stateToProps, dispatchToProps)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/index.js